import React from "react";
import { Link } from "react-router-dom";

import "../scss/jumbotron.scss";

const Jumbotron = () => {
  return (
    <div className="jumbotron">
      <div className="jumbo-wrapper">
        <h1 className="header-title">
          Votre projet, concrétisé par des étudiants
        </h1>
        <Link to="/newproject" className="btn-project">
          Commencer l'aventure !
        </Link>
      </div>
    </div>
  );
};

export default Jumbotron;
